import { AFFAIR_STAGE_GROUPS } from '../affairModel';
import AffairKanbanColumn from './AffairKanbanColumn';

export default function AffairKanban({ action, affairs, onRequestTransition }) {
  const visibleGroups = AFFAIR_STAGE_GROUPS.filter(({ stages }) => !stages.includes('abandoned') || affairs.some((affair) => stages.includes(affair.stage)));

  return (
    <div className="affair-kanban" aria-label="Pipeline des affaires">
      {visibleGroups.map(({ key, label, stages }) => (
        <AffairKanbanColumn
          key={key}
          stageKey={key}
          label={label}
          affairs={affairs.filter((affair) => stages.includes(affair.stage))}
          action={action}
          onRequestTransition={onRequestTransition}
        />
      ))}
    </div>
  );
}
